// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"1da4c7d7","488":"f43a7029"}[chunkId] + ".chunk.js";
};